/**
 *
 * DisableCustomerCarePopup
 *
 * @version 1.0.0
 * @author Vittorio Scaperrotta
 * @since 27-Jan-2023
 */

import React from 'react';
import PropTypes from 'prop-types';
import PortalModal from 'Components/PortalModal/PortalModal';
import formattedMessages from '../../modules/languageModule';
import style from './DisableCustomerCarePopup.scss';

const DisableCustomerCarePopup = (props) => (
	<PortalModal
		className={style.container}
		title={formattedMessages.warning}
		subtitle={formattedMessages.subtitleDisable}
		actions={{ handleClose: () => {} }}
		buttons={[
			{
				variant: 'outlined',
				onClick: props.actions.closeModal,
				contentText: formattedMessages.abortLabelButton,
			},
			{
				variant: 'contained',
				onClick: () => {
					props.actions.disableCard(props.payload);
				},
				contentText: formattedMessages.confirmLabelButton,
				isLoading: props.isLoading,
			},
		]}
	/>
);

DisableCustomerCarePopup.propTypes = {
	// Add here some propTypes
	actions: PropTypes.objectOf(PropTypes.func),
	isLoading: PropTypes.bool,
	status: PropTypes.string,
	payload: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
};

DisableCustomerCarePopup.defaultProps = {
	// Add here some default propTypes values
	isLoading: PropTypes.false,
	status: '',
	payload: {},
};

export default DisableCustomerCarePopup;
